const container = (css, theme, styleUtils) => css`
  ${styleUtils.flex.container({
  inline: true
})};
  border-radius: ${theme.borderRadius.medium};
`;

const containerBackground = (css, theme, styleUtils) => name => css`
  background-color: ${styleUtils.color.picker({
  seed: name,
  choices: [theme.color.designSystem.purple60, theme.color.designSystem.success, theme.color.designSystem.error]
})};
`;

const small = (css, theme, styleUtils) => css`
  ${styleUtils.base.square({
  size: '24px'
})};
`;

const medium = (css, theme, styleUtils) => css`
  ${styleUtils.base.square({
  size: '32px'
})};
`;

const large = (css, theme, styleUtils) => css`
  ${styleUtils.base.square({
  size: '40px'
})};
`;

const xLarge = (css, theme, styleUtils) => css`
  ${styleUtils.base.square({
  size: '48px'
})};
`;

const text = (css, theme, styleUtils) => css`
  ${styleUtils.typography.copy({
  weight: 'bold'
})};
  color: ${theme.color.white};
`;

const onlineIndicator = (css, theme) => css`
  position: absolute;
  top: -8px;
  left: -8px;
  border: ${theme.borderRadius.small} solid ${theme.color.white};
  height: 10px;
  width: 10px;
`;

const image = (css, theme) => css`
  position: absolute;
  border-radius: ${theme.borderRadius.medium};
`;

export default ((css, theme, styleUtils) => ({
  container: {
    base: container(css, theme, styleUtils),
    background: containerBackground(css, theme, styleUtils)
  },
  text: {
    base: text(css, theme, styleUtils)
  },
  onlineIndicator: {
    base: onlineIndicator(css, theme)
  },
  image: {
    base: image(css, theme)
  },
  bySize: {
    small: small(css, theme, styleUtils),
    medium: medium(css, theme, styleUtils),
    large: large(css, theme, styleUtils),
    xLarge: xLarge(css, theme, styleUtils)
  }
}));
//# sourceMappingURL=Avatar.shared.style.js.map